import { Leaf, Award, Heart, Recycle } from "lucide-react";

const items = [
  {
    icon: Leaf,
    title: "Eco-Friendly Manufacturing",
    description: "Our 4 plants use energy-efficient processes with significant reduction in water usage since 2018. Sustainable sourcing of raw materials from verified suppliers — sourced locally to minimize carbon footprint.",
    stat: "Less water usage"
  },
  {
    icon: Recycle,
    title: "Waste Reduction",
    description: "Zero-waste production target — we recycle 100% of packaging materials and convert by-products into organic fertilizers. All feed bags are made from recyclable HDPE material.",
    stat: "100% recyclable packaging"
  },
  {
    icon: Heart,
    title: "Community Initiatives",
    description: "We train 2,000+ farmers through free workshops, field demonstrations, and on-farm consultation programs. Fair pricing policies help small-scale farmers thrive.",
    stat: "2,000+ farmers trained"
  },
  {
    icon: Award,
    title: "Quality Certifications",
    description: "ISO 9001:2015 certified manufacturing. BIS IS 1374 compliant formulations. Regular audits by NABL-accredited laboratories for raw material and finished product testing.",
    stat: "ISO 9001:2015"
  },
];

const SustainabilitySection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-accent font-body text-sm font-semibold tracking-widest uppercase">Our Responsibility</span>
          <h2 className="text-3xl md:text-4xl font-bold font-display text-primary mt-3">Sustainability & CSR</h2>
          <p className="text-muted-foreground font-body mt-4 max-w-2xl mx-auto">
            We're committed to responsible manufacturing, environmental stewardship, and uplifting the farming communities we serve across 20+ states.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div key={i} className="flex gap-5 p-6 bg-card border border-border rounded-xl hover:shadow-md transition-shadow">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="h-6 w-6 text-primary" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-display font-bold text-foreground text-lg">{item.title}</h3>
                    <span className="text-[10px] uppercase tracking-wider text-accent font-body font-semibold bg-accent/10 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {item.stat}
                    </span>
                  </div>
                  <p className="text-muted-foreground font-body text-sm mt-2 leading-relaxed">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SustainabilitySection;
